document.addEventListener('algolia.hooks.initialize', function() {
  // Exclure les croisières de l'Autocomplete (recherche prédictive)
  algoliaShopify.hooks.registerHook('beforeAutocompleteFiltersString', function(filters) {
    var exclusion = 'NOT product_type:cruise';
    if (filters && filters.length > 0) {
      return filters + ' AND ' + exclusion;
    }
    return exclusion;
  });

  // Exclure les croisières de l'InstantSearch (page résultats)
  algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function() {
    const { configure } = window.algoliaShopify.externals.widgets;
    const configureWidget = configure({
      filters: "NOT product_type:cruise"
    });
    return [configureWidget];
  });
});